import request from "@/utils/request";

export default function agentUnBundDevice(params) {
    return request({
        url: `/device/device/agentUnBundDevice`,
        method: 'post',
        params
    })
}
